import * as searchWidgetActions from '../../../../actions/searchWidgetActions';

function getCommonUtils(searchWidgetDispatch) {
  const onTrainClicked = (train, isMobile) => {
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_CALENDAR_OPEN,
      data: true
    });
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_FROM_STATION_NODE,
      data: {
        cityMweb: train.sourceCity,
        city: !isMobile ? train.sourceCityEn : train.sourceCity,
        code: train.sourceStn
      }
    });
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_TO_STATION_NODE,
      data: {
        cityMweb: train.destinationCity,
        city: !isMobile ? train.destinationCityEn : train.destinationCity,
        code: train.destinationStn
      }
    });
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_TRAIN_NUMBER,
      data: train.trainNumber
    });
  };
  const onTrainExtraSectionClicked = ({
    fromCityEn,
    toCityEn,
    isMobile,
    fromCity,
    fromStn,
    toCity,
    toStn,
    trainNumber
  }) => {
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_CALENDAR_OPEN,
      data: true
    });
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_FROM_STATION_NODE,
      data: {
        cityMweb: fromCity,
        city: !isMobile ? fromCityEn : fromCity,
        code: fromStn
      }
    });
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_TO_STATION_NODE,
      data: {
        cityMweb: toCity,
        city: !isMobile ? toCityEn : toCity,
        code: toStn
      }
    });
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_TRAIN_NUMBER,
      data: trainNumber
    });
  };
  return { onTrainClicked, onTrainExtraSectionClicked };
}

function getRouteInfoPageUtils(searchWidgetDispatch) {
  const onMountInitSearchWidgetWrapper = (data) => {
    const onMountInitSearchWidget = () => {
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_FROM_STATION_NODE,
        data: {
          cityMweb: data.fromCity,
          city: data.fromCity,
          code: data.fromCityCode
        }
      });
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_TO_STATION_NODE,
        data: {
          cityMweb: data.toCity,
          city: data.toCity,
          code: data.toCityCode
        }
      });
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_TO_CITY_NAME,
        data: data.tokens.destinationCityEn
      });
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_FROM_CITY_NAME,
        data: data.tokens.sourceCityEn
      });
    };
    return onMountInitSearchWidget;
  };
  const updateCityNameWithFilter = ({ fromFilter, toFilter, data }) => {
    if (toFilter.city !== data.tokens.destinationCityEn && toFilter.city !== data.tokens.destination) {
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_TO_CITY_NAME,
        data: toFilter.city
      });
    }
    if (fromFilter.city !== data.tokens.sourceCityEn && fromFilter.city !== data.tokens.source) {
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_FROM_CITY_NAME,
        data: fromFilter.city
      });
    }
  };
  const onTrainClicked = (train) => {
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_CALENDAR_OPEN,
      data: true
    });
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_TRAIN_NUMBER,
      data: train.trainNumber
    });
  };

  return {
    ...getCommonUtils(searchWidgetDispatch),
    onTrainClicked,
    updateCityNameWithFilter,
    onMountInitSearchWidgetWrapper
  };
}
function getTrainInfoPageUtils(searchWidgetDispatch) {
  const onMountInitSearchWidgetWrapper = (data) => {
    const onMountInitSearchWidget = () => {
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_FROM_STATION_NODE,
        data: {
          cityMweb: data.sourceCity.obj.cityName,
          city: data.sourceCity.obj.cityName,
          code: data.sourceStation.stationCode
        }
      });
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_TO_STATION_NODE,
        data: {
          cityMweb: data.destinationCity.obj.cityName,
          city: data.destinationCity.obj.cityName,
          code: data.destinationStation.stationCode
        }
      });
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_TO_CITY_NAME,
        data: data.destinationCity.obj.cityNameEn
      });
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_FROM_CITY_NAME,
        data: data.sourceCity.obj.cityNameEn
      });
    };
    return onMountInitSearchWidget;
  };
  const updateCityNameWithFilter = ({ fromFilter, toFilter, data }) => {
    if (toFilter.city !== data.destinationCity.obj.cityName && toFilter.city !== data.destinationCity.obj.cityNameEn) {
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_TO_CITY_NAME,
        data: toFilter.city
      });
    }
    if (fromFilter.city !== data.sourceCity.obj.cityName && fromFilter.city !== data.sourceCity.obj.cityNameEn) {
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_FROM_CITY_NAME,
        data: fromFilter.city
      });
    }
  };
  return { ...getCommonUtils(searchWidgetDispatch), updateCityNameWithFilter, onMountInitSearchWidgetWrapper };
}

function getStationInfoPageUtils(searchWidgetDispatch) {
  const onMountInitSearchWidgetWrapper = (data) => {
    const onMountInitSearchWidget = () => {
      searchWidgetDispatch({
        type: searchWidgetActions.ACTION_UPDATE_FROM_STATION_NODE,
        data: {
          cityMweb: data && data.stationInfo && data.stationInfo.obj && data.stationInfo.obj.city,
          city: data && data.stationInfo && data.stationInfo.obj && data.stationInfo.obj.city,
          code: data && data.stationInfo && data.stationInfo.obj && data.stationInfo.obj.code
        }
      });
    };
    return onMountInitSearchWidget;
  };
  return { ...getCommonUtils(searchWidgetDispatch), onMountInitSearchWidgetWrapper };
}

function getCovidSpecialPageUtils(searchWidgetDispatch) {
  return { ...getCommonUtils(searchWidgetDispatch) };
}

function getFestiveSpecialTrainUtils(searchWidgetDispatch) {
  return { ...getCommonUtils(searchWidgetDispatch) };
}

function getKumbhMelaTrainUtils(searchWidgetDispatch) {
  return { ...getCommonUtils(searchWidgetDispatch) };
}

function getSearchWidgetComponentUtils(searchWidgetDispatch) {
  const closeCalendar = () => {
    searchWidgetDispatch({ type: searchWidgetActions.ACTION_UPDATE_CALENDAR_OPEN, data: false });
  };
  const openCalendar = () => {
    searchWidgetDispatch({ type: searchWidgetActions.ACTION_UPDATE_CALENDAR_OPEN, data: true });
  };
  const setFromCity = (fromCity, fromCityCode) => {
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_FROM_STATION_NODE,
      data: {
        cityMweb: fromCity,
        city: fromCity,
        code: fromCityCode
      }
    });
  };
  const setToCity = (toCity, toCityCode) => {
    searchWidgetDispatch({
      type: searchWidgetActions.ACTION_UPDATE_TO_STATION_NODE,
      data: {
        cityMweb: toCity,
        city: toCity,
        code: toCityCode
      }
    });
  };
  return { closeCalendar, openCalendar, setFromCity, setToCity };
}

export const SEARCH_WIDGET_UTILS = {
  STATION_INFO_UTILS: getStationInfoPageUtils,
  TRAIN_INFO_UTILS: getTrainInfoPageUtils,
  ROUTE_INFO_UTILS: getRouteInfoPageUtils,
  COVID_SPECIAL_TRAINS_UTILS: getCovidSpecialPageUtils,
  FESTIVE_SPECIAL_TRAINS: getFestiveSpecialTrainUtils,
  KUMBH_MELA_TRAINS: getKumbhMelaTrainUtils,
  SEARCH_COMPONENT_UTILS: getSearchWidgetComponentUtils
};
export default SEARCH_WIDGET_UTILS;
